import React, { useEffect, useRef, useState } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import { Row, Tabs, Tab, Table, Col, Accordion, Modal } from 'react-bootstrap';
import { get, patch, post } from '../../services/apiController';
import Breadcrumb from '../../components/Breadcrumb';
import { useParams } from 'react-router-dom';
import AgreementAddEditModal from './components/AgreementAddEditModal';
import { DeleteIcon, DownloadIcon, EditIcon, UploadIcon } from '../icons';
import { GetYearLabel, dateFormat, months } from '../../util/helper';
import { FiSave } from 'react-icons/fi';
import DocumentUploadModal from './components/DocumentUploadModal';
import MonthlyInvoiceUpload from './components/MonthlyInvoiceUpload';
import { GrDocumentPdf } from 'react-icons/gr';
import moment from 'moment';
import AlertIcon from '../../img.svg';
import PreClosureModal from './components/PreClosureModal';

const AgreementView = () => {
  const [data, setData] = useState({});
  const { agreementId } = useParams();
  const [step, setStep] = useState(null);
  const [ownerDetailId, setOwnerDetailId] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [documentUploadModal, setDocumentUploadModal] = useState(false);
  const [monthlyInvoiceModal, setMonthlyInvoiceModal] = useState(false);
  const [monthlyInvoiceId, setMonthlyInvoiceId] = useState(null);
  const [documentType, setDocumentType] = useState('');
  const clickToDownload = useRef(null);
  const [documentShowConfirmModel, setDocumentShowConfirmModel] = useState(false);
  const [fieldToDeleted, setFieldToDeleted] = useState(null);
  const [preClosureModal, setPreClosureModal] = useState(false);

  const handleShowModal = (e, step, ownerDetailId = null) => {
    setShowModal(true);
    setStep(step);
    setOwnerDetailId(ownerDetailId);
  };

  const handleCloseDocumentConfirmModal = () => {
    setDocumentShowConfirmModel(false);
    setFieldToDeleted(null);
  };

  const GetAgreementDetail = (conditionType = '') => {
    get(`/agreements/${agreementId}?conditionType=${conditionType}`)
      .then((res) => {
        if (conditionType === 'pdf') {
          clickToDownload.current.href = `${process.env.REACT_APP_BASE_URL}/file/download?filePath=${res.data}`;
          setTimeout(() => {
            clickToDownload.current.click();
          }, 500);
        } else {
          setData(res.data);
        }
      })
      .catch((err) => {
        toast.error(err?.response?.data?.data?.message || err.message);
      });
  };

  useEffect(() => {
    if (agreementId) {
      GetAgreementDetail();
    }
  }, [agreementId]);

  const handleShowDocumentConfirmModal = (e, index) => {
    e.preventDefault();
    setDocumentShowConfirmModel(true);
    setFieldToDeleted(index);
  };

  const handleDeleteImage = (agreementId, index) => {
    post({ agreementId, index }, `/agreements/delete-documents`, false)
      .then((res) => {
        toast.success(res?.data?.message);
        handleCloseDocumentConfirmModal();
        GetAgreementDetail();
      })
      .catch((err) => toast.error(err?.response?.data?.data?.message || err.message));
  };

  const handleInputChange = (e, index) => {
    const { name, value } = e.target;
    const updatedDetails = [...data.AgreementIncrementDetails];
    if (name === 'incrementPercentage') {
      const lastYearRent = index === 0 ? data.rentOrLeaseAmount : updatedDetails[index - 1]['inAmount'];
      updatedDetails[index] = {
        ...updatedDetails[index],
        incrementPercentage: value,
        inAmount: (value * lastYearRent) / 100 + +lastYearRent,
      };
      setData({ ...data, AgreementIncrementDetails: updatedDetails });
    } else {
      updatedDetails[index] = {
        ...updatedDetails[index],
        [name]: value,
      };
      setData({ ...data, AgreementIncrementDetails: updatedDetails });
    }
  };

  const handleSaveChanges = (index) => {
    const incrementDetail = data.AgreementIncrementDetails[index];
    const dataToUpdate = {
      incrementPercentage: incrementDetail.incrementPercentage,
      inAmount: incrementDetail.inAmount,
    };
    // Assuming you have a save endpoint
    patch(dataToUpdate, `/agreements/increment/${incrementDetail.id}`)
      .then((res) => toast.success(res?.data?.message))
      .catch((err) => toast.error(err?.response?.data?.data?.message || err.message));
  };

  const handleInvoiceUpload = (e, type, ownerDetailId = null) => {
    e.preventDefault();
    setDocumentType(type);
    setDocumentUploadModal(true);
    setOwnerDetailId(ownerDetailId);
  };

  return (
    <React.Fragment>
      <ToastContainer />
      <Breadcrumb
        navigation={[
          { link: '/agr/agreement-list', title: 'Agreement List' },
          { link: '#', title: 'Details' },
        ]}
      />
      <div className="card">
        <div className="card-header white-color" style={{ padding: '1rem 1.7rem' }}>
          <h4 className="card-title mb-0" style={{ fontSize: '16px' }}>
            Agreement Details
          </h4>
          <div className="d-flex">
            {!data.isPreClosed && !data.isShopClosed && (
              <button type="button" className="btn app-btn-danger me-2" onClick={() => setPreClosureModal(true)}>
                Pre-Close Agreement
              </button>
            )}
            <a ref={clickToDownload} href="/" target="_blank" className="hiddenItem">
              HiddenClick
            </a>
          </div>
        </div>
        <div className="card-body">
          <Row className="top-row">
            <div className="col-md-2">
              <dd className="display-title mb-1">Location Type</dd>
              <dt className="display-value text-capitalize">{data?.Branch?.type}</dt>
            </div>
            <div className="col-md-2">
              <dd className="display-title mb-1">Location</dd>
              <dt className="display-value">
                {data?.Branch?.name} ({data?.Branch?.number})
              </dt>
            </div>
            <div className="col-md-2">
              <dd className="display-title mb-1">Location Adress</dd>
              <dt className="display-value">{data?.Branch?.address}</dt>
            </div>
            <div className="col-md-2">
              <dd className="display-title mb-1">Reference Location</dd>
              <dt className="display-value">{data?.referenceLocation}</dt>
            </div>
            {data.isPreClosed && (
              <div className="col-md-4">
                <dd className="display-title mb-1 text-danger">Pre-Closed Agreement</dd>
                <dt className="display-value">
                  <strong>Date:</strong> {data?.preClosureDate}
                  <br />
                  <strong>Approved By:</strong> {data?.preClosureApprovedBy}
                  <br />
                  <strong>Reason:</strong> {data?.preClosureReason}
                </dt>
              </div>
            )}
          </Row>
        </div>
      </div>
      <Row style={{ marginBottom: '-30px' }}>
        <Col xs={12} className="text-end pe-5">
          <GrDocumentPdf onClick={() => GetAgreementDetail('pdf')} className="react-icons red" title="download pdf" />
        </Col>
      </Row>
      <div>
        <Tabs defaultActiveKey={'owner-details'} id="uncontrolled-tab-example" className="mb-3">
          <Tab eventKey="owner-details" title="Owner Details">
            <div className="card">
              <div className="card-header white-color" style={{ padding: '1rem 1.7rem' }}>
                <h4 className="card-title mb-0" style={{ fontSize: '16px' }}>
                  Owner Details
                </h4>
                {!data.isShopClosed && !data.isPreClosed && (
                  <button type="button" className="btn app-btn-default dark-color" onClick={(e) => handleShowModal(e, 2)}>
                    Add New Owner
                  </button>
                )}
              </div>
              <div className="card-body">
                <Accordion defaultActiveKey={[]} alwaysOpen>
                  {data?.OwnerDetails?.map((owner, index) => {
                    return (
                      <Row key={index}>
                        <Col xs={11}>
                          <Accordion.Item className="border mb-3" eventKey={index}>
                            <Accordion.Header>
                              <div className="d-flex justify-content-between w-100 align-items-center">
                                <span>{`Owner ${index + 1}: ${owner?.ownerName || 'New Owner'},${'  '} ${
                                  owner?.rentShareInPercent
                                }%  Share`}</span>
                              </div>
                            </Accordion.Header>
                            <Accordion.Body>
                              <Row className="top-row">
                                <div className="col-md-3">
                                  <dd className="display-title mb-1">Name</dd>
                                  <dt className="display-value text-capitalize">{owner?.ownerName}</dt>
                                </div>
                                <div className="col-md-3">
                                  <dd className="display-title mb-1">Email</dd>
                                  <dt className="display-value">{owner?.ownerEmail}</dt>
                                </div>
                                <div className="col-md-3">
                                  <dd className="display-title mb-1">Phone No.</dd>
                                  <dt className="display-value">{owner?.ownerPhoneNo}</dt>
                                </div>
                                <div className="col-md-12">
                                  <dd className="display-title mb-1">Address</dd>
                                  <dt className="display-value">{owner?.ownerAddress}</dt>
                                </div>
                                <div className="col-md-3">
                                  <dd className="display-title mb-1">PAN No.</dd>
                                  <dt className="display-value">{owner?.ownerPanNo}</dt>
                                </div>
                                <div className="col-md-3">
                                  <dd className="display-title mb-1">PAN Card Image</dd>
                                  <dt className="display-value">
                                    {owner?.ownerPanImage ? (
                                      <a
                                        href={`${process.env.REACT_APP_BASE_URL}/${owner?.ownerPanImage}`}
                                        target="_blank"
                                        rel="noreferrer"
                                      >
                                        <DownloadIcon style={{ color: 'purple' }} />
                                      </a>
                                    ) : (
                                      !data.isPreClosed &&
                                      !data.isShopClosed && (
                                        <a href="/" onClick={(e) => handleInvoiceUpload(e, 'ownerPanImage', owner.id)}>
                                          <UploadIcon style={{ color: 'green' }} />
                                        </a>
                                      )
                                    )}
                                  </dt>
                                </div>
                                <div className="col-md-3">
                                  <dd className="display-title mb-1">AADHAR No.</dd>
                                  <dt className="display-value">{owner?.ownerAadharNo}</dt>
                                </div>
                                <div className="col-md-3">
                                  <dd className="display-title mb-1">AADHAR Card Images</dd>
                                  <dt className="display-value">
                                    {Array.isArray(owner?.ownerAadharImages) && owner?.ownerAadharImages.length > 0
                                      ? owner?.ownerAadharImages?.map((image, index) => (
                                          <a
                                            key={index}
                                            href={`${process.env.REACT_APP_BASE_URL}/${image}`}
                                            target="_blank"
                                            rel="noreferrer"
                                          >
                                            <DownloadIcon style={{ color: 'purple', marginRight: '10px' }} />
                                          </a>
                                        ))
                                      : !data.isPreClosed &&
                                        !data.isShopClosed && (
                                          <a href="/" onClick={(e) => handleInvoiceUpload(e, 'ownerAadharImages', owner.id)}>
                                            <UploadIcon style={{ color: 'green' }} />
                                          </a>
                                        )}
                                  </dt>
                                </div>
                                <div className="col-md-3">
                                  <dd className="display-title mb-1">Bank Name</dd>
                                  <dt className="display-value">{owner?.ownerBankName}</dt>
                                </div>
                                <div className="col-md-3">
                                  <dd className="display-title mb-1">Account Number</dd>
                                  <dt className="display-value">{owner?.ownerAccountNumber}</dt>
                                </div>
                                <div className="col-md-3">
                                  <dd className="display-title mb-1">IFSC Code</dd>
                                  <dt className="display-value">{owner?.ownerIfsc}</dt>
                                </div>
                                <div className="col-md-3">
                                  <dd className="display-title mb-1">Cancelled Cheque</dd>
                                  <dt className="display-value">
                                    {owner?.cancelledChequeImage ? (
                                      <a
                                        href={`${process.env.REACT_APP_BASE_URL}/${owner?.cancelledChequeImage}`}
                                        target="_blank"
                                        rel="noreferrer"
                                      >
                                        <DownloadIcon style={{ color: 'purple' }} />
                                      </a>
                                    ) : (
                                      !data.isPreClosed &&
                                      !data.isShopClosed && (
                                        <a href="/" onClick={(e) => handleInvoiceUpload(e, 'cancelledChequeImage', owner.id)}>
                                          <UploadIcon style={{ color: 'green' }} />
                                        </a>
                                      )
                                    )}
                                  </dt>
                                </div>
                              </Row>
                            </Accordion.Body>
                          </Accordion.Item>
                        </Col>
                        <Col xs={1}>
                          {!data.isShopClosed && !data.isPreClosed && (
                            <span onClick={(e) => handleShowModal(e, 2, owner.id)} className="edit-icon ms-auto">
                              <EditIcon style={{ color: 'teal', cursor: 'pointer' }} />
                            </span>
                          )}
                        </Col>
                      </Row>
                    );
                  })}
                </Accordion>
              </div>
            </div>
          </Tab>
          <Tab eventKey="tenant-details" title="Tenant Details">
            <div className="card">
              <div className="card-header white-color" style={{ padding: '1rem 1.7rem' }}>
                <h4 className="card-title mb-0" style={{ fontSize: '16px' }}>
                  Tenant Details
                </h4>
                {!data.isShopClosed && !data.isPreClosed && (
                  <span onClick={(e) => handleShowModal(e, 3)} className="edit-icon">
                    <EditIcon style={{ color: 'teal' }} />
                  </span>
                )}
              </div>
              <div className="card-body">
                <Row className="top-row">
                  <div className="col-md-12">
                    <dd className="display-title mb-1">Name</dd>
                    <dt className="display-value text-capitalize">{data?.tenantName}</dt>
                  </div>
                  <div className="col-md-12">
                    <dd className="display-title mb-1">Address</dd>
                    <dt className="display-value">{data?.tenantAddress}</dt>
                  </div>
                  <div className="col-md-12">
                    <dd className="display-title mb-1">Email</dd>
                    <dt className="display-value">{data?.tenantEmail}</dt>
                  </div>
                  <div className="col-md-12">
                    <dd className="display-title mb-1">Phone No.</dd>
                    <dt className="display-value">{data?.tenantPhoneNo}</dt>
                  </div>
                </Row>
              </div>
            </div>
          </Tab>
          <Tab eventKey="recitals" title="Recitals">
            <div className="card">
              <div className="card-header white-color" style={{ padding: '1rem 1.7rem' }}>
                <h4 className="card-title mb-0" style={{ fontSize: '16px' }}>
                  Recitals
                </h4>
                {!data.isShopClosed && !data.isPreClosed && (
                  <span onClick={(e) => handleShowModal(e, 4)} className="edit-icon">
                    <EditIcon style={{ color: 'teal' }} />
                  </span>
                )}
              </div>
              <div className="card-body">
                <Row className="top-row">
                  <div className="col-md-4">
                    <dd className="display-title mb-1">Stamp Duty Amount</dd>
                    <dt className="display-value">₹ {data?.stampDutyAmount}</dt>
                  </div>
                  <div className="col-md-4">
                    <dd className="display-title mb-1">Registration Charges</dd>
                    <dt className="display-value">₹ {data?.registrationCharge}</dt>
                  </div>
                  <div className="col-md-4">
                    <dd className="display-title mb-1">Agreement Executed Date</dd>
                    <dt className="display-value">{data?.agreementExecutedDate}</dt>
                  </div>
                  <div className="col-md-4">
                    <dd className="display-title mb-1">Floor</dd>
                    <dt className="display-value">{data?.floor}</dt>
                  </div>
                  <div className="col-md-4">
                    <dd className="display-title mb-1">Square Feet</dd>
                    <dt className="display-value">{data?.squareFeet}</dt>
                  </div>
                  <div className="col-md-4">
                    <dd className="display-title mb-1">Power Deposit And Consumption</dd>
                    <dt className="display-value">{data?.powerDepositAndConsumption}</dt>
                  </div>
                  <div className="col-md-12">
                    <dd className="display-title mb-1">Address</dd>
                    <dt className="display-value">{data?.address}</dt>
                  </div>
                  <div className="col-md-12">
                    <dd className="display-title mb-1">Purpose</dd>
                    <dt className="display-value">{data?.purpose}</dt>
                  </div>
                  <div className="col-md-3">
                    <dd className="display-title mb-1">Effective Date</dd>
                    <dt className="display-value">{data?.effectiveDate}</dt>
                  </div>
                  <div className="col-md-3">
                    <dd className="display-title mb-1">Agreement End Date</dd>
                    <dt className="display-value">{data?.agreementEndDate}</dt>
                  </div>
                  <div className="col-md-3">
                    <dd className="display-title mb-1">Rent/Lease Amount</dd>
                    {data?.underGst ? (
                      <dt className="display-value">
                        ₹ {`${data?.rentOrLeaseAmount} (Without GST)`}
                        <br />₹{' '}
                        {`${parseFloat(data.rentOrLeaseAmount) + parseFloat((data.rentOrLeaseAmount * data.gstRate) / 100)} (With GST)`}
                      </dt>
                    ) : (
                      <dt className="display-value">₹ {data?.rentOrLeaseAmount}</dt>
                    )}
                  </div>
                  <div className="col-md-3">
                    <dd className="display-title mb-1">Under GST</dd>
                    <dt className="display-value">{data?.underGst ? 'Yes' : 'No'}</dt>
                  </div>
                  {data?.underGst && (
                    <>
                      <div className="col-md-3">
                        <dd className="display-title mb-1">GST Number</dd>
                        <dt className="display-value">{data?.gstNumber}</dt>
                      </div>
                      <div className="col-md-3">
                        <dd className="display-title mb-1">GST Rate</dd>
                        <dt className="display-value">{data?.gstRate}</dt>
                      </div>
                    </>
                  )}
                  <div className="col-md-3">
                    <dd className="display-title mb-1">Security Deposit Amount</dd>
                    <dt className="display-value">₹ {data?.securityDepositAmount}</dt>
                  </div>
                  <div className="col-md-3">
                    <dd className="display-title mb-1">Maintenance Charges</dd>
                    <dt className="display-value">₹ {data?.maintenanceCharges}</dt>
                  </div>
                  <div className="col-md-3">
                    <dd className="display-title mb-1">Water Charges</dd>
                    <dt className="display-value">₹ {data?.waterCharges}</dt>
                  </div>
                  <div className="col-md-3">
                    <dd className="display-title mb-1">Other Charges</dd>
                    <dt className="display-value">₹ {data?.otherCharges}</dt>
                  </div>
                  <div className="col-md-3">
                    <dd className="display-title mb-1">Charges Remarks</dd>
                    <dt className="display-value">{data?.chargesRemark}</dt>
                  </div>
                  <div className="col-md-3">
                    <dd className="display-title mb-1">Documents</dd>
                    <dt className="display-value">
                      {Array.isArray(data?.agreementFiles) && data?.agreementFiles.length > 0
                        ? data?.agreementFiles?.map((image, index) => (
                            <>
                              <dt className="display-value mb-1">
                                {image}
                                {!data.isPreClosed && (
                                  <DeleteIcon
                                    style={{ color: 'rgb(220, 53, 69)', cursor: 'pointer', marginLeft: '15px' }}
                                    onClick={(e) => handleShowDocumentConfirmModal(e, index)}
                                  />
                                )}
                                <a key={index} href={`${process.env.REACT_APP_BASE_URL}/${image}`} target="_blank" rel="noreferrer">
                                  <DownloadIcon style={{ color: 'purple', marginLeft: '10px' }} />
                                </a>
                              </dt>
                            </>
                          ))
                        : !data.isPreClosed &&
                          !data.isShopClosed && (
                            <a href="/" onClick={(e) => handleInvoiceUpload(e, 'agreementFiles')}>
                              <UploadIcon style={{ color: 'green' }} />
                            </a>
                          )}
                    </dt>
                  </div>
                </Row>
              </div>

              <div className="card-body vehicle-requests-table">
                <h6>Owner Sharing Details</h6>
                {Array.isArray(data.OwnerDetails) && data.OwnerDetails.length > 0 ? (
                  <Table responsive striped bordered>
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Owner</th>
                        <th>Share in %</th>
                        <th>Without GST</th>
                        <th>With GST</th>
                      </tr>
                    </thead>
                    <tbody>
                      {data.OwnerDetails.map((owner, index) => {
                        return (
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td>{owner?.ownerName}</td>
                            <td>{owner?.rentShareInPercent} %</td>
                            <td>{(owner?.rentShareInPercent / 100) * data.rentOrLeaseAmount}</td>
                            <td>
                              {(
                                (owner?.rentShareInPercent / 100) *
                                (data.rentOrLeaseAmount + (data.rentOrLeaseAmount * data.gstRate) / 100)
                              ).toFixed(2) || 0}
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </Table>
                ) : (
                  <span className="text-danger">No Owner Details Added Yet</span>
                )}
              </div>
              {/* Rent Increment details table */}
              <div className="card-body vehicle-requests-table">
                <h6>Increment Details</h6>
                <Table responsive striped bordered className="bill-detail-table">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Start Date</th>
                      <th>End Date</th>
                      <th>Percentage Increment</th>
                      <th>In Amounts</th>
                      <th>In Amounts With GST</th>
                      {!data.isShopClosed && !data.isPreClosed && <th>Actions</th>}
                    </tr>
                  </thead>
                  <tbody>
                    {data?.AgreementIncrementDetails &&
                      Array.isArray(data?.AgreementIncrementDetails) &&
                      data?.AgreementIncrementDetails.map((inc, index) => {
                        const isOldIncrement = moment(inc?.toDate).isSameOrBefore(data.effectiveDate);
                        return (
                          <tr key={index}>
                            <td className={isOldIncrement || data.isPreClosed ? 'highlightCell' : undefined}>{GetYearLabel(index + 1)}</td>
                            <td className={isOldIncrement || data.isPreClosed ? 'highlightCell' : undefined}>
                              {dateFormat(inc?.fromDate)}
                            </td>
                            <td className={isOldIncrement || data.isPreClosed ? 'highlightCell' : undefined}>{dateFormat(inc?.toDate)}</td>
                            <td className={isOldIncrement || data.isPreClosed ? 'highlightCell' : undefined}>
                              {data.isShopClosed || data.isPreClosed || isOldIncrement ? (
                                inc?.incrementPercentage
                              ) : (
                                <input
                                  value={inc.incrementPercentage ?? ''}
                                  name="incrementPercentage"
                                  onChange={(e) => handleInputChange(e, index)}
                                  type="text"
                                  placeholder="Increment percentage"
                                />
                              )}
                            </td>
                            <td className={isOldIncrement || data.isPreClosed ? 'highlightCell' : undefined}>
                              {data.isShopClosed || data.isPreClosed || isOldIncrement ? (
                                inc?.inAmount
                              ) : (
                                <input
                                  value={inc.inAmount ?? ''}
                                  name="inAmount"
                                  onChange={(e) => handleInputChange(e, index)}
                                  type="text"
                                  placeholder="In Amounts"
                                />
                              )}
                            </td>
                            <td className={isOldIncrement || data.isPreClosed ? 'highlightCell' : undefined}>
                              {inc?.inAmount !== '' && typeof data?.gstRate === 'number'
                                ? (+inc.inAmount + (+inc.inAmount * data.gstRate) / 100).toFixed(2)
                                : 'N/A'}
                            </td>
                            {!data.isShopClosed && !data.isPreClosed && (
                              <td className={isOldIncrement ? 'highlightCell' : undefined}>
                                {isOldIncrement ? (
                                  'Old Increment'
                                ) : (
                                  <FiSave
                                    title="Update Item rate&gst"
                                    style={{ cursor: 'pointer', height: '25px', width: '25px', color: 'green', marginLeft: '6px' }}
                                    onClick={() => handleSaveChanges(index)}
                                  />
                                )}
                              </td>
                            )}
                          </tr>
                        );
                      })}
                  </tbody>
                </Table>
              </div>
            </div>
          </Tab>
          <Tab eventKey="invoice-upload" title="Invoice Upload">
            <div className="card-header white-color" style={{ padding: '1rem 1.7rem' }}>
              <h4 className="card-title mb-0" style={{ fontSize: '16px' }}>
                Invoices
              </h4>
              {data.agreementExecutedDate && data.agreementEndDate && !data.isPreClosed && (
                <button type="button" className="btn app-btn-default dark-color" onClick={() => setMonthlyInvoiceModal(true)}>
                  Create New Entry
                </button>
              )}
            </div>
            <div className="card-body vehicle-requests-table">
              <Table responsive striped bordered>
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Month</th>
                    <th>Rent Amount</th>
                    <th>Water Charges Amount</th>
                    <th>Maintenance Amount</th>
                    {!data.isShopClosed && !data.isPreClosed && <th>Actions</th>}
                  </tr>
                </thead>
                <tbody>
                  {data?.MonthlyInvoices &&
                    Array.isArray(data?.MonthlyInvoices) &&
                    data?.MonthlyInvoices.map((item, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{`${months[item?.month]} ${item?.year}`}</td>
                        <td>
                          <div className="d-flex">
                            <p
                              style={{
                                margin: '0 12px 0px 0',
                              }}
                            >
                              {item?.rentAmount}
                            </p>
                            {item?.rentInvoice && (
                              <a href={`${process.env.REACT_APP_BASE_URL}/${item?.rentInvoice}`} target="_blank" rel="noreferrer">
                                <DownloadIcon style={{ color: 'purple' }} />
                              </a>
                            )}
                          </div>
                        </td>
                        <td>
                          <div className="d-flex">
                            <p
                              style={{
                                margin: '0 12px 0px 0',
                              }}
                            >
                              {item?.waterAmount}
                            </p>
                            {item?.waterInvoice && (
                              <a href={`${process.env.REACT_APP_BASE_URL}/${item?.waterInvoice}`} target="_blank" rel="noreferrer">
                                <DownloadIcon style={{ color: 'purple' }} />
                              </a>
                            )}
                          </div>
                        </td>
                        <td>
                          <div className="d-flex">
                            <p
                              style={{
                                margin: '0 12px 0px 0',
                              }}
                            >
                              {item?.maintenanceAmount}
                            </p>
                            {item?.maintenanceInvoice && (
                              <a href={`${process.env.REACT_APP_BASE_URL}/${item?.maintenanceInvoice}`} target="_blank" rel="noreferrer">
                                <DownloadIcon style={{ color: 'purple' }} />
                              </a>
                            )}
                          </div>
                        </td>
                        {!data.isShopClosed && !data.isPreClosed && (
                          <td>
                            <span
                              onClick={(e) => {
                                setMonthlyInvoiceModal(true);
                                setMonthlyInvoiceId(item?.id);
                              }}
                              className="edit-icon"
                            >
                              <EditIcon style={{ color: 'teal' }} />
                            </span>
                          </td>
                        )}
                      </tr>
                    ))}
                </tbody>
              </Table>
            </div>
          </Tab>
        </Tabs>
      </div>
      {showModal && (
        <AgreementAddEditModal
          open={showModal}
          onClose={() => {
            setShowModal(false);
            setStep(null);
            setOwnerDetailId(null);
          }}
          agreementId={agreementId}
          callback={GetAgreementDetail}
          step={step}
          ownerDetailId={ownerDetailId}
        />
      )}
      {documentUploadModal && (
        <DocumentUploadModal
          documentType={documentType}
          agreementId={agreementId}
          open={documentUploadModal}
          onClose={() => {
            setDocumentUploadModal(false);
            setOwnerDetailId(null);
          }}
          ownerDetailId={ownerDetailId}
          callback={GetAgreementDetail}
        />
      )}
      {monthlyInvoiceModal && (
        <MonthlyInvoiceUpload
          monthlyInvoiceId={monthlyInvoiceId}
          data={data}
          open={monthlyInvoiceModal}
          onClose={() => {
            setMonthlyInvoiceModal(false);
            setMonthlyInvoiceId(null);
          }}
          callback={GetAgreementDetail}
        />
      )}
      <Modal size="sm" show={documentShowConfirmModel} backdrop="static" keyboard={false} className="request-modal">
        <Modal.Header className="bg-danger text-light py-2">
          <Modal.Title>Delete Document</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="d-flex justify-content-start">
            <img src={AlertIcon} />
            <p className="ps-3 mb-0">Are you sure? Action cannot be undone.</p>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="btn-wrapper">
            <button onClick={handleCloseDocumentConfirmModal} className="btn app-btn-default btn-sm">
              Cancel
            </button>
            <button onClick={() => handleDeleteImage(agreementId, fieldToDeleted)} className="btn app-btn-danger btn-sm">
              Delete
            </button>
          </div>
        </Modal.Footer>
      </Modal>
      {preClosureModal && (
        <PreClosureModal
          open={preClosureModal}
          onClose={() => setPreClosureModal(false)}
          agreementId={agreementId}
          callback={GetAgreementDetail}
        />
      )}
    </React.Fragment>
  );
};

export default AgreementView;
